import { useEffect, useState } from 'react';
import { fetchUsersFromGetStream } from '../utils/user';
import useChatClient from '../useChatClient';
import { GetStreamUser } from '../types/GetStreamUser';

const useGetBannedUsersByTimer = () => {
    const [filteredUsers, setFilteredUsers] = useState<GetStreamUser[]>([]);
    const { client } = useChatClient();

    // fetch users every minute
    const FETCH_USER_SECONDS = 30;

    const queryUsersFromGetStream = async () => {
        const users = await fetchUsersFromGetStream(client, { banned: true });
        setFilteredUsers(users);
    };

    useEffect(() => {
        const timer = setInterval(() => {
            queryUsersFromGetStream();
        }, FETCH_USER_SECONDS * 1000);
        return () => clearInterval(timer);
    }, []);

    return filteredUsers;
};

export default useGetBannedUsersByTimer;
